import { C } from "../components/reporting/reportingStyles";

/** Mirrors the API's src/const/pushCampaign.js. */

export const CAMPAIGN_STATUS = {
  draft: "draft",
  scheduled: "scheduled",
  sending: "sending",
  sent: "sent",
  failed: "failed",
  cancelled: "cancelled",
};

export const STATUS_META = {
  draft: { label: "Draft", color: C.textMed, bg: C.borderLight },
  scheduled: { label: "Scheduled", color: C.blue, bg: C.blueLight },
  sending: { label: "Sending…", color: C.orange, bg: C.orangeLight },
  sent: { label: "Sent", color: C.green, bg: C.greenLight },
  failed: { label: "Failed", color: C.coral, bg: C.coralLight },
  cancelled: { label: "Cancelled", color: C.textLight, bg: C.bg },
};

export const AUDIENCE_TYPES = [
  { value: "all", label: "All customers", hint: "Everyone linked to this merchant who has not opted out." },
  { value: "ordered_within", label: "Ordered in the last N days", hint: "Recent, active customers." },
  { value: "not_ordered_within", label: "Not ordered in the last N days", hint: "Win-back: customers who have gone quiet." },
  { value: "wallet_pass", label: "Has the Wallet card installed", hint: "Customers holding the Apple Wallet loyalty card." },
];

export const AUDIENCE_LABELS = Object.fromEntries(AUDIENCE_TYPES.map((a) => [a.value, a.label]));

export const DEEP_LINK_SCREENS = [
  { value: "home", label: "Home" },
  { value: "loyalty", label: "Loyalty card" },
  { value: "membership", label: "Membership" },
  { value: "orders", label: "Orders" },
  { value: "wallet", label: "Wallet" },
  { value: "product", label: "A product" },
];

export const SCREEN_LABELS = Object.fromEntries(DEEP_LINK_SCREENS.map((s) => [s.value, s.label]));

export const LIMITS = { name: 120, title: 100, body: 300, titleAdvised: 50, bodyAdvised: 180, imageBytes: 1024 * 1024 };

/** Short audience description for the table. */
export const describeAudience = (audience = {}) => {
  const parts = [AUDIENCE_LABELS[audience.type] || "All customers"];
  if (audience.days && (audience.type === "ordered_within" || audience.type === "not_ordered_within")) {
    parts[0] = parts[0].replace("N days", `${audience.days} days`);
  }
  if (audience.lang) parts.push(audience.lang.toUpperCase());
  if (audience.platform) parts.push(audience.platform === "ios" ? "iOS" : "Android");
  return parts.join(" · ");
};

/** Audit labels for the campaign history tab (AuditLogPanel, module "marketing"). */
export const CAMPAIGN_AUDIT_ACTION_LABELS = {
  create: "Draft created",
  update: "Edited",
  send_now: "Sent now",
  schedule: "Scheduled",
  cancel: "Cancelled",
  duplicate: "Duplicated",
  test_send: "Test sent",
  sent: "Delivery finished",
  failed: "Delivery failed",
};

export const CAMPAIGN_AUDIT_FIELD_LABELS = {
  name: "Name",
  titleEn: "Title (EN)",
  bodyEn: "Body (EN)",
  titleAr: "Title (AR)",
  bodyAr: "Body (AR)",
  audience: "Audience",
  deepLink: "Opens",
  appId: "App",
  status: "Status",
  scheduledAt: "Scheduled for",
  imagePath: "Image",
  image: "Image",
  targetedUsers: "Customers targeted",
  targetedTokens: "Devices targeted",
  sentCount: "Delivered",
  failedCount: "Failed",
  prunedCount: "Dead devices removed",
  lastError: "Note",
  phoneNo: "Test phone",
  tokens: "Devices",
  sent: "Sent",
  failed: "Failed",
  pruned: "Removed",
  sourceCampaignId: "Copied from campaign",
  sentBeforeCancel: "Delivered before cancel",
  note: "Note",
  fatal: "Fatal",
};

export const campaignAuditResolve = (field, value) => {
  if (field === "audience" && value && typeof value === "object") return describeAudience(value);
  if (field === "deepLink") {
    if (!value) return "Home";
    return value.screen === "product" ? `Product #${value.productId}` : SCREEN_LABELS[value.screen] || value.screen;
  }
  if (field === "status") return STATUS_META[value]?.label || value;
  return undefined;
};
